import React from 'react';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { t } from 'i18next';
import ExpenseDetails from './ExpenseDetails';
import { NoteDataItem, NoteDetailResponse } from 'features/expenses/types/type';
import { hasPermission } from 'utils/permissions';

export const actionsBody = (toggleRefreshDT: () => void) => {
  const ActionsButton = (rowData: NoteDataItem) => {
    const { openSidebar } = useSidebarManager();
    if (hasPermission('Profile.Expenses.Edit')) {
      return (
        <button
          onClick={() =>
            openSidebar(ExpenseDetails, true, {
              noteId: rowData.id,
              toggleRefreshDT: toggleRefreshDT,
            })
          }
          className="minthr-btn minthr-btn-icon-origin minthr-btn-light-gray minthr-btn-round minthr-p-0 minthr-sidebar-open"
        >
          <img
            className="minthr-icon-xs"
            src="/icons/arrow.svg"
            alt="View Details"
          />
        </button>
      );
    }
  };
  ActionsButton.displayName = 'ActionsButton';
  return ActionsButton;
};

export const statusBody = (rowData: NoteDataItem) => {
  const statusMap: {
    [key: number]: { label: string; badgeClass: string; colorClass: string };
  } = {
    0: {
      label: t('Draft'),
      badgeClass: 'minthr-badge-mystic',
      colorClass: 'minthr-color-mystic',
    },
    1: {
      label: t('Pending'),
      badgeClass: 'minthr-badge-warning',
      colorClass: 'minthr-color-warning',
    },
    2: {
      label: t('Success'),
      badgeClass: 'minthr-badge-success',
      colorClass: 'minthr-color-success',
    },
    3: {
      label: t('Refund'),
      badgeClass: 'minthr-badge-info',
      colorClass: 'minthr-color-info',
    },
    4: {
      label: t('Rejected'),
      badgeClass: 'minthr-badge-danger',
      colorClass: 'minthr-color-danger',
    },
    5: {
      label: t('canceled.status'),
      badgeClass: 'minthr-badge-danger',
      colorClass: 'minthr-color-danger',
    },
  };

  const { label, badgeClass, colorClass } = statusMap[rowData.status];

  return (
    <>
      <span className={`minthr-badge ${badgeClass}`}>{label}</span>
      <br />
      <span className={`text-s ${colorClass} minthr-ml-2`}>
        {rowData.historyDate}
      </span>
    </>
  );
};

export const statusMap: {
  [key: string]: { label: string; className: string };
} = {
  0: { label: 'Draft', className: 'minthr-badge-mystic' },
  1: { label: 'Pending', className: 'minthr-badge-warning' },
  2: { label: 'Success', className: 'minthr-badge-success' },
  3: { label: 'Refund', className: 'minthr-badge-info' },
  4: { label: 'Rejected', className: 'minthr-badge-danger' },
  5: { label: 'Canceled', className: 'minthr-badge-danger' },
};

export const statusColors: { [key: string]: string } = {
  Success: 'success',
  Pending: 'warning',
  Refund: 'info',
  Draft: 'warning',
  Canceled: 'danger',
  Rejected: 'danger',
};

export function getStatusColor(status: string): string | undefined {
  return statusColors[status];
}

function getStatusKey(model: NoteDetailResponse): string {
  if (model?.status === 0 || model?.status === 5) {
    return 'Pending';
  }
  if (model?.status === 1 || model?.nextStatus === 'Success') {
    return 'Success';
  }
  return 'Refund';
}

export const getClassStatus = (model: NoteDetailResponse) => {
  const statusKey = getStatusKey(model);
  return getStatusColor(statusKey);
};

export const getStatusText = (model: NoteDetailResponse) => {
  if (model?.status === 0 || model?.status === 5) {
    return t('soumis');
  }
  if (model?.status === 1 || model?.nextStatus === 'Success') {
    return t('Success1');
  }
  return t('Refund1');
};
